import React from 'react';
import { AppBar, Stack, Toolbar } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Logo } from '../../Logo';
import STRING_KEYS from '../../../language/keys';
import { AI_APPS, ROUTES, aiAppUrl } from '../../../consts';
import { PERMISSIONS } from '../../../consts/permissions';
import { useAuth } from '../../../hooks/useAuth';
import Tabs, { Tab } from '../Tabs';
import AiAppsMenu from '../AiAppsMenu';
import Account from '../Account';
import { style } from './style';

const defaultTabs = [
  {
    key: STRING_KEYS.LAYOUT_HOME_TITLE,
    redirectPath: ROUTES.HOME,
    permissions: [],
  },
  {
    key: STRING_KEYS.LAYOUT_SALES_TITLE,
    redirectPath: ROUTES.SALES.SEARCH_ACCOUNT,
    permissions: [PERMISSIONS.SALES_FLOW],
  },
  {
    key: STRING_KEYS.LAYOUT_POSITION_TITLE,
    redirectPath: ROUTES.POSITIONS,
    permissions: [PERMISSIONS.POSITION_VIEW],
  },
  {
    key: STRING_KEYS.LAYOUT_ACCOUNTS_TITLE,
    redirectPath: ROUTES.ACCOUNTS,
    permissions: [PERMISSIONS.ACCOUNT_VIEW],
  },
  {
    key: STRING_KEYS.LAYOUT_REFERRALS_TITLE,
    redirectPath: ROUTES.REFERRALS,
    permissions: [PERMISSIONS.REFERRAL_VIEW],
  },
];

// Standalone agent-native apps (Clips, Analytics) shown as top-level tabs that
// open the app in a new browser tab rather than embedding it in an iframe.
const externalAppTabs: Tab[] = AI_APPS.filter((a) => a.external).map((a) => ({
  key: a.key,
  title: a.label,
  redirectPath: aiAppUrl(a.key),
  external: true,
}));

const LayoutHeader = ():JSX.Element => {
  const { t: translate } = useTranslation();
  const location = useLocation();
  const { hasPermissions } = useAuth();
  const firstPath = location.pathname.split('/')[1];
  const tabs = defaultTabs.filter((tab) => {
    return hasPermissions(tab.permissions);
  }).map((tab): Tab => {
    const { redirectPath, key } = tab;
    const active = redirectPath.substring(1) === firstPath;

    return {
      ...tab,
      title: translate(key),
      active,
    };
  });

  return (
    <AppBar position={ style.appBar.position } sx={ style.appBar.sx }>
      <Toolbar>
        <Logo />
        <Stack
          direction={ style.stack.direction }
          spacing={ style.stack.spacing }
          sx={ style.stack.sx }
        >
          <Tabs elements={ [...tabs, ...externalAppTabs] } />
          <AiAppsMenu />
        </Stack>
        <Account />
      </Toolbar>
    </AppBar>
  );
};

export default LayoutHeader;
